import axios from 'axios'

// API 基础 URL 配置
// 开发环境使用代理（空字符串），生产环境使用当前域名
const isDevelopment = process.env.NODE_ENV === 'development'
export const SHARE_URL = isDevelopment
  ? '' // 开发环境：使用代理，请求本地路径
  : window.location.origin // 生产环境：当前域名

export const OAUTH_URL1 = 'https://saas.aishare.io/' // 新 PLUS 站点首选地址
export const OAUTH_URL2 = 'https://saas.aishare.icu/' // 新 PLUS 站点备用地址 1
export const OAUTH_URL3 = 'https://saas.likeky.com/' // 新 PLUS 站点备用地址 2

// AI 绘图站地址（纯前端写死；为空则不展示侧边栏入口）
export const DRAWING_URL = 'https://drawing.aishare.io' // 首选地址
export const DRAWING_URL2 = 'https://drawing.aishare.icu' // 备用地址 1（原首选地址）
export const DRAWING_URL3 = 'https://drawing.likeky.com' // 备用地址 2
// export const DRAWING_URL = 'http://127.0.0.1:8888'

// 在以下域名下，隐藏 Gemini / GPT Codex / AI 绘图站 这三项功能
// 匹配规则：window.location.hostname 完全等于 或 以「.域名」结尾（即覆盖子域名）
// 例如配置 'example.com' 会同时命中 example.com / www.example.com / a.b.example.com
// 留空数组则不启用此功能
export const HIDE_FEATURES_DOMAINS = [
  'ikun.aishare.icu',
  'tudou.aishare.icu'
]

// 当前域名是否命中「隐藏指定功能」名单
export const shouldHideRestrictedFeatures = () => {
  try {
    const host = (window.location.hostname || '').toLowerCase()
    if (!host) return false
    return HIDE_FEATURES_DOMAINS.some(d => {
      const dom = String(d || '').toLowerCase().trim()
      if (!dom) return false
      return host === dom || host.endsWith('.' + dom)
    })
  } catch (e) {
    return false
  }
}
// 创建 axios 实例 - SHARE API
export const shareAxios = axios.create({
  baseURL: SHARE_URL,
  timeout: 15000,
  withCredentials: true, // 允许携带 Cookie
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json'
  }
})

// SHARE API 响应拦截器
shareAxios.interceptors.response.use(
  response => {
    // 直接返回响应数据
    return response.data
  },
  error => {
    // 详细的错误处理
    if (error.response) {
      // 服务器返回了错误状态码
      console.error('API错误:', error.response.status, error.response.data)
    } else if (error.request) {
      // 请求已发送但没有收到响应
      console.error('网络错误: 无法连接到服务器')
    } else {
      // 请求配置出错
      console.error('请求配置错误:', error.message)
    }
    return Promise.reject(error)
  }
)
